<template>
    <li class="border-iron2 border-b last:border-b-0">
        <div class="py-6 pr-5 pr-5 lg-down:pl-5 lg-2xl:pl-5 pl-40">

            <div class="flex flex-col">
                <div class="w-full">
                        <strong v-on:click="this.handleExpandClick" :class="{'text-lochmara': !this.expanded}" class="text-cinnabar block font-bold transition-colors duration-250 relative leading-none mb-1 cursor-pointer flex items-center">
                                <div :class="{'text-iron2': !this.expanded}" class="text-cinnabar lg-down:m-0 lg-2xl:m-0 lg-down:mr-2 lg-2xl:mr-2 lg-down:static lg-2xl:static absolute left-0 inset-y-0 my-auto h-2 -m-6">
                                    <svg class="transform transition duration-250" :class="{'rotate-180': this.expanded}" width="12" height="7"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path class="fill-current transition"
                                              d="M6 5.137L10.731.226c.2903-.3013.761-.3013 1.0513 0 .2903.3014.2903.79 0 1.0913L6.5257 6.774c-.2904.3013-.761.3013-1.0514 0L.2177 1.3173c-.2903-.3013-.2903-.79 0-1.0913.2903-.3013.761-.3013 1.0514 0L6 5.137z"
                                              fill-rule="evenodd"/>
                                    </svg>
                                </div>{{this.title}}</strong>
                        <span class="ml-5 block font-bold text-shuttle text-xs">{{ '{distance} miles away'|t({distance: distance}) }}</span>
                </div>
                <div class="w-full ml-5">
                    <transition enter-class="scale-y-0" enter-to-class="scale-y-full" leave-class="scale-y-full" leave-to-class="scale-y-0">
                        <div v-if="this.expanded" class="block w-full transform transition-all origin-top duration-250">
                            <div class="flex lg:flex-col lg:flex-row">
                                <div class="flex-auto w-7/12">
                                    <div class="flex flex-col">
                                        <div class="my-3">
                                            <address class="text-shuttle font-normal has-br text-xs not-italic">{{address}}<br/> {{this.dealerAddress.parts.city}}, {{this.dealerAddress.parts.state}} {{this.dealerAddress.parts.postcode}}</address>
                                        </div>
                                        <div>
                                            <div class="text-shuttle text-xs"><span>{{'Phone:'|t}} </span><a :href="'tel:'+this.phoneNumber" class="text-lochmara underline">{{this.phoneNumber}}</a></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-auto w-5/12">
                                    <div class="lg:flex lg:justify-end items-end h-full mt-3 lg:mt-0">
                                        <div class="inline-block mr-3">
                                            <a target="_blank" :href="directions" class="text-sm text-shark group">
                                                <span class="font-bold">{{'Get Directions'|t}}</span>
                                                <div class="flex items-center -mt-2">
                                                    <div class="flex-auto -mr-2">
                                                        <hr class="border-t-2 border-cinnabar">
                                                    </div>
                                                    <div class="text-cinnabar -mr-3">
                                                        <svg class="transition accelerate group-hover:translate-x-2px" height="14" width="9" xmlns="http://www.w3.org/2000/svg"><path d="m2 14.071-1.4142-1.414 5.6568-5.657-5.6568-5.6569 1.4142-1.4141 7.071 7.071-1.414 1.4142-5.657 5.6569z" fill="#dc441c" fill-rule="evenodd"/></svg>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="w-full flex-grow relative ml-5" :class="{'mt-2': this.categories.length || this.backerboardOnly}">
                  <div class="flex justify-start space-x-1">
                              <span
                                  v-for="category in categories"
                                  class="bg-lochmara text-xxs font-bold text-white text-center py-1 px-2"
                              >
                                {{ category.title }}
                              </span>
                    <span
                        v-if="backerboardOnly"
                        class="bg-lochmara text-xxs font-bold text-white text-center py-1 px-2"
                    >
                                Backerboard Only
                              </span>
                  </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
    export default {
        props: {
            dealerAddress: Object,
            phoneNumber: String,
            title: String,
            backerboardOnly: Boolean,
            categories: Array,
            emailAddress: String,
            directions: String,
            uid: String
        },
        data: () => {
            return {
                expanded: false
            }
        },
        computed: {
            distance: function() {
                return Number((this.dealerAddress.distance).toFixed(2));
            },
            address: function () {
                // Handle some formatting weirdness
                if (typeof this.dealerAddress.parts.street_number !== "undefined" && typeof this.dealerAddress.parts.route !== "undefined") {
                    return this.dealerAddress.parts.street_number + ' ' + this.dealerAddress.parts.route;
                }
                if (typeof this.dealerAddress.parts.number !== "undefined" && typeof this.dealerAddress.parts.address !== "undefined") {
                    return this.dealerAddress.parts.number + ' ' + this.dealerAddress.parts.address;
                }
                if (typeof this.dealerAddress.parts.address !== "undefined") {
                    return this.dealerAddress.parts.address;
                }
            }
        },
        name: 'DealerItemDesktop',
        mounted() {
            this.$events.$on('pinclicked', (dealer) => {
                this.expanded = dealer.uid === this.uid;
            });
        },
        methods: {
            handleExpandClick() {
                this.expanded = !this.expanded;
                if (this.expanded) {
                    this.$emit('expanded', {dealerAddress: this.dealerAddress, uid: this.uid});
                }
            }
        }
    }
</script>
